import { postRequest, formDataRequest } from "../libs/AxiosService.util";

export async function serviceCreateReward(params) {
  return await formDataRequest("rewards/create", params);
}

export async function serviceUpdateReward(params) {
  return await formDataRequest("rewards/update", params);
}

export async function serviceDeleteReward(params) {
  return await postRequest("rewards/delete", params);
}
export async function serviceCheckReward(params) {
  return await postRequest("rewards/check", params);
}

export async function serviceGetReward(params) {
  return await postRequest("rewards", params);
}
export async function serviceGetProgramReward(params) {
  return await postRequest("programs/rewards", params);
}
export async function serviceGetRewardDetails(params) {
  return await postRequest("rewards/detail", params);
}
export async function serviceUpdateRewardPriority(params) {
  return await postRequest("rewards/update/priority", params);
}
export async function serviceProgramRewardAssociate(params) {
  return await postRequest("programs/rewards/associate", params);
}
export async function serviceGetRewardHistory(params) {
  return await postRequest("rewards/user/history/credit", params);
}
export async function serviceGetSubsriptionList(params) {
  return await postRequest("subscription/user", params);
}
export async function serviceGetWalletHistory(params) {
  return await postRequest("rewards/user/history", params);
}
